import { QueryCache, QueryClient, MutationCache } from '@tanstack/react-query';
import { ApiError } from './api';

function shouldRetry(count: number, err: unknown): boolean {
  if (err instanceof ApiError) {
    if (err.status === 0) return count < 2;
    if (err.status >= 400 && err.status < 500) return false;
  }
  return count < 2;
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache(),
  mutationCache: new MutationCache(),
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst',
      staleTime: 30_000,
      gcTime: 24 * 3600_000,
      retry: shouldRetry,
      refetchOnWindowFocus: true,
    },
    mutations: { networkMode: 'offlineFirst', retry: false },
  },
});
